import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import PropTypes from 'prop-types';
import arrowRightIcon from '../../assets/icons/Arrow_Right.svg';

const PinkGradientButtonWithArrow = ({
    label,
    onClick,
    sx = {},
    arrowPosition = 'right', // 'right' or 'left'
    buttonStyle = 'default',
}) => {
    const isFigmaCta = buttonStyle === 'figmaCta';
    const ArrowIcon = arrowPosition === 'left' ? ArrowBackRoundedIcon : ArrowForwardRoundedIcon;
    const figmaSidePadding = {
        start: { xs: '17.6px', md: '22.4px' },
        arrow: { xs: '7.04px', md: '8.96px' },
    };
    const buttonSx = isFigmaCta
        ? {
              background: '#FF669B',
              color: 'white',
              borderRadius: '224px',
              height: { xs: '44px', md: '56px' },
              width: 'auto',
              minWidth: 'unset',
              textTransform: 'none',
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: { xs: '14px', md: '18px' },
              lineHeight: { xs: '14px', md: '18px' },
              letterSpacing: { xs: '-0.28px', md: '-0.36px' },
              textShadow: {
                  xs: '0 0 8.8px rgba(35, 7, 88, 0.10)',
                  md: '0 0 11.2px rgba(35, 7, 88, 0.10)',
              },
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: { xs: '12.419px', md: '15.806px' },
              pl: arrowPosition === 'left' ? figmaSidePadding.arrow : figmaSidePadding.start,
              pr: arrowPosition === 'right' ? figmaSidePadding.arrow : figmaSidePadding.start,
              py: 0,
              transition: 'none',
              '&:hover': {
                  background: '#FF669B',
                  color: 'white',
                  boxShadow: 'none',
              },
              ...sx,
          }
        : {
              background: '#FF669B',
              color: 'white',
              borderRadius: '36px',
              height: '68px',
              width: '100%',
              maxWidth: '333px',
              textTransform: 'none',
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              pl: arrowPosition === 'left' ? '70px' : '25px',
              pr: arrowPosition === 'right' ? '70px' : '25px',
              position: 'relative',
              transition: 'none',
              '&:hover': {
                  background: '#FF669B',
                  color: 'white',
                  boxShadow: 'none',
              },
              ...sx,
          };

    return (
        <Button onClick={onClick} sx={buttonSx}>
            {/* Arrow on the left */}
            {arrowPosition === 'left' &&
                (isFigmaCta ? (
                    <ArrowCircle direction="left" />
                ) : (
                    <DefaultArrowCircle position="left" ArrowIcon={ArrowIcon} />
                ))}

            {/* Label */}
            <Typography
                variant="inherit"
                sx={{
                    fontSize: 'inherit',
                    fontWeight: 500,
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit',
                    whiteSpace: 'nowrap',
                    ...(!isFigmaCta && { fontSize: sx.fontSize || '20px' }),
                }}
            >
                {label}
            </Typography>

            {/* Arrow on the right */}
            {arrowPosition === 'right' &&
                (isFigmaCta ? (
                    <ArrowCircle direction="right" />
                ) : (
                    <DefaultArrowCircle position="right" ArrowIcon={ArrowIcon} />
                ))}
        </Button>
    );
};

const DefaultArrowCircle = ({ position, ArrowIcon }) => (
    <Box
        sx={{
            position: 'absolute',
            [position]: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'white',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        <ArrowIcon sx={{ color: '#BD8DE8', fontSize: '24px' }} />
    </Box>
);

const ArrowCircle = ({ direction }) => (
    <Box
        sx={{
            backgroundColor: 'white',
            borderRadius: '50%',
            width: { xs: '30.8px', md: '39.2px' },
            height: { xs: '30.8px', md: '39.2px' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
        }}
    >
        <Box
            component="img"
            src={arrowRightIcon}
            alt=""
            sx={{
                width: { xs: '14.14px', md: '18px' },
                height: { xs: '7.85px', md: '10px' },
                transform: direction === 'left' ? 'scaleX(-1)' : 'none',
            }}
        />
    </Box>
);

DefaultArrowCircle.propTypes = {
    position: PropTypes.oneOf(['left', 'right']).isRequired,
    ArrowIcon: PropTypes.elementType.isRequired,
};

ArrowCircle.propTypes = {
    direction: PropTypes.oneOf(['left', 'right']).isRequired,
};

PinkGradientButtonWithArrow.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    sx: PropTypes.object,
    arrowPosition: PropTypes.oneOf(['left', 'right']),
    buttonStyle: PropTypes.oneOf(['default', 'figmaCta']),
};

export default PinkGradientButtonWithArrow;
